module.exports = __webpack_public_path__ + "static/media/short_notes.2711db2b.png";